import { render, staticRenderFns } from "./ChangeIconPopup.vue?vue&type=template&id=405604f2&"
import script from "./ChangeIconPopup.vue?vue&type=script&lang=js&"
export * from "./ChangeIconPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports